import { AssetManager as AssetManager } from "./game/AssetManager";
import { config } from "./game/consts/config";
import { Game } from "./game/logic/Game";
import { Statistics } from "./statistics/statistics";

export class App {
    public games: Array<Game> = [];
    public statistics: Statistics;
    public assets: AssetManager = new AssetManager();

    constructor() {
        const game_canvases = document.getElementsByClassName('game-instance');
        for (let i = 0; i < game_canvases.length; ++i) {
            const game_canvas = game_canvases.item(i);
            if (!(game_canvas instanceof HTMLCanvasElement)) continue;
            this.games.push(new Game(game_canvas, this.assets));
        }
        const statistics_canvas = document.getElementById("statistics-screen");
        if (!(statistics_canvas instanceof HTMLCanvasElement)) throw new Error();
        this.statistics = new Statistics(statistics_canvas, this.games);
    }

    private last_update_time_seconds: number = 0;
    public readonly delta_step = 1 / 60;

    public update(time_seconds: number) {
        const delta_seconds = time_seconds - this.last_update_time_seconds;
        this.last_update_time_seconds = time_seconds;
        this.games.forEach(game => {
            // game.update(delta_seconds * config.game_time_multiplier);
            for (let i = 0; i < config.game_time_multiplier; ++i) {
                game.update(this.delta_step);
            }
            game.view.update();
            game.agent.update(this.delta_step);
        });
        this.statistics.update();
    }

    public run() {
        requestAnimationFrame((time: number) => {
            this.last_update_time_seconds = time / 1000;
        });
        const loop = (time_milli_seconds: number = 0) => {
            this.update(time_milli_seconds / 1000);
            requestAnimationFrame(loop);
        }
        requestAnimationFrame(loop);
    }
}